import {push} from 'connected-react-router';
import {RouteKeys} from '../constants';

/**
 * Action Creators
 */
export const redirectToCodeExpired = () => (dispatch) => {
  dispatch(push(RouteKeys.CodeExpired.value));
};

export const redirectToProposalSendSucess = () => (dispatch) => {
  dispatch(push(RouteKeys.ProposalSendSucess.value));
};

export const redirectToIntermediateReturn = () => (dispatch) => {
  dispatch(push(RouteKeys.IntermediateReturn.value));
};

export const redirectToInitialRegistration = () => (dispatch) => {
  dispatch(push(RouteKeys.InitialRegistration.value));
};

export const redirectToDataRegistration = () => (dispatch) => {
  dispatch(push(RouteKeys.DataRegistration.value));
};

export const redirectToDataContact = () => (dispatch) => {
  dispatch(push(RouteKeys.DataContact.value));
};

export const redirectToEndDataRegistration = () => (dispatch) => {
  dispatch(push(RouteKeys.EndDataRegistration.value));
};

export const redirectToDataDocument = () => (dispatch) => {
  dispatch(push(RouteKeys.DataDocument.value));
};

export const redirectToDataResidential = () => (dispatch) => {
  dispatch(push(RouteKeys.DataResidential.value));
};

export const redirectToDataProfessional = () => (dispatch) => {
  dispatch(push(RouteKeys.DataProfessional.value));
};

export const redirectToPhotoTime = () => (dispatch) => {
  dispatch(push(RouteKeys.PhotoTime.value));
};

export const redirectToTakeYourPicture = () => (dispatch) => {
  dispatch(push(RouteKeys.TakeYourPicture.value));
};

export const redirectToConfirmYourPicture = () => (dispatch) => {
  dispatch(push(RouteKeys.ConfirmYourPicture.value));
};

export const redirectToDocumentTime = () => (dispatch) => {
  dispatch(push(RouteKeys.DocumentTime.value));
};

export const redirectToDocumentVerse = () => (dispatch) => {
  dispatch(push(RouteKeys.DocumentVerse.value));
};

export const redirectToYourCard = () => (dispatch) => {
  dispatch(push(RouteKeys.YourCard.value));
};

export const redirectToTermsAccept = () => (dispatch) => {
  dispatch(push(RouteKeys.TermsAccept.value));
};

export const redirectToRemakePreEvaluation = () => (dispatch) => {
  dispatch(push(RouteKeys.RemakePreEvaluation.value));
};

export const redirectToConfirmationPhotoDocument = (verso) => (dispatch) => {
  if (verso) dispatch(push(RouteKeys.ConfirmationPhotoDocumentBack.value));
  else dispatch(push(RouteKeys.ConfirmationPhotoDocument.value));
};

export const redirectToTakePhotoDocument = (verso) => (dispatch) => {
  if (verso) dispatch(push(RouteKeys.TakeYourPictureDocumentBack.value));
  else dispatch(push(RouteKeys.TakeYourPictureDocument.value));
};

export const redirectToSignatureExample = () => (dispatch) => {
  dispatch(push(RouteKeys.SignatureExample.value));
};

export const redirectToSignature = () => (dispatch) => {
  dispatch(push(RouteKeys.Signature.value));
};

export const redirectToSignatureNotFound = () => (dispatch) => {
  dispatch(push(RouteKeys.SignatureNotFound.value));
};

export const redirectToUpdateYourData = () => (dispatch) => {
  dispatch(push(RouteKeys.UpdateYourData.value));
};

export const redirectToValidationAccessCode = () => (dispatch) => {
  dispatch(push(RouteKeys.ValidationAccessCode.value));
};

export const redirectToValidateCodeSms = () => (dispatch) => {
  dispatch(push(RouteKeys.ValidateCodeSms.value));
};
export const redirectToConfirmPhoneSuccess = () => (dispatch) => {
  dispatch(push(RouteKeys.ConfirmPhoneSuccess.value));
};

export const redirectToFinish = () => (dispatch) => {
  dispatch(push(RouteKeys.Finish.value));
};

export const redirectToProcessingPreEvaluation = () => (dispatch) => {
  dispatch(push(RouteKeys.ProcessingPreEvaluation.value));
};

export const redirectToPreEvaluationCompleted = () => (dispatch) => {
  dispatch(push(RouteKeys.PreEvaluationCompletedSuccess.value));
};

export const redirectToHireInsurance = () => (dispatch) => {
  dispatch(push(RouteKeys.HireInsurance.value));
};

export const redirectToAdditionalCard = () => (dispatch) => {
  dispatch(push(RouteKeys.AdditionalCard.value));
};
